import { Display } from '@/components/Display/Display';
import UsualSkillReference from './components/UsualSkillReference';
import { third_json_handler } from '@/utils/Page/constant';
const WebReference = (props) => {
    const { isTargetSkillType, curSkill, ...restProps } = props;
    return (
        <>
            <Display show={isTargetSkillType && isTargetSkillType(curSkill?.ability_id, third_json_handler.file_chat)}>
                <UsualSkillReference {...restProps}></UsualSkillReference>
            </Display>
        </>
    );
};

export default WebReference;
